//export { VdsAutocompleteModule } from './vds-autocomplete.module';
export * from './vds-search-box.component';
export * from './vds-search-result.component';